// extracted by mini-css-extract-plugin
export default {"cell":"styles_cell__rIxTR","text":"styles_text__J9pYw","empty":"styles_empty__Hi6ti","hint":"styles_hint__mXFVa","meta":"styles_meta__NXWj7"};